export const heroSlides = [
  {
    id: "passion",
    label: "Awaken",
    title: "Awaken the",
    accent: "passion.",
    text: "A range of premium products designed to elevate pleasure, passion and performance — delivered discreetly to your door.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/87eac4e2-8824-453e-a031-a932b1a7e2be.jpg",
    imagePosition: "object-[72%_center]",
    primary: { label: "Shop all products", to: "/shop" },
    secondary: { label: "Discover Seven Sins", to: "/shop?collection=seven-sins" },
    productSlug: "seven-sins-master",
  },
  {
    id: "her",
    label: "For her",
    title: "Her pleasure,",
    accent: "amplified.",
    text: "Lady in Red, Pink Pussycat and Spanish Fly — formulas crafted to heighten her desire and sensation.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/4e3c5605-b0b4-4415-9441-b245be10e79d.jpg",
    imagePosition: "object-[50%_30%]",
    primary: { label: "Shop for her", to: "/shop?for=her" },
    secondary: { label: "View Pink Pussycat", to: "/product/pink-pussycat" },
    productSlug: "pink-pussycat",
  },
  {
    id: "honey",
    label: "Royal honey",
    title: "Liquid gold",
    accent: "for your nights.",
    text: "Single-use royal honey sachets that work in minutes. Tear, take, and feel the difference — all from €14,99.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/dfee1b62-aca4-4220-9e8e-134b45927c79.jpg",
    imagePosition: "object-center",
    primary: { label: "Shop honey", to: "/shop?collection=royal-honey" },
    secondary: { label: "View VIP Royal Honey", to: "/product/vip-royal-honey" },
    productSlug: "vip-royal-honey",
  },
  {
    id: "him",
    label: "For him",
    title: "Power when",
    accent: "it matters.",
    text: "Seven Sins, royal honey and gels for stamina, energy and confidence — whenever the moment calls.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/99e91c93-6ffb-4724-a57d-f16d34a0790b.jpg",
    imagePosition: "object-[50%_25%]",
    primary: { label: "Shop for him", to: "/shop?for=him" },
    secondary: { label: "View Seven Sins Boost", to: "/product/seven-sins-boost" },
    productSlug: "seven-sins-boost",
  },
];
